/* eslint-disable no-param-reassign */
import 'semantic-ui-css/semantic.min.css';
import 'isomorphic-fetch';
import '@babel/polyfill';

import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { render } from 'react-dom';

import loggerMiddleware from '../r/store/middleware/logger';
import { registerSW } from '../r/components/form/utils';
import rootReducer from '../r/store/reducers';
import FormBase from '../r/components/form';
import { getEnvironment } from '../r/utils';

const inProduction = getEnvironment() === 'production';

const Root = ({ store }) => (
  <Provider store={store}>
    <FormBase />
  </Provider>
);

const preloadedState = {};
const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggerMiddleware(inProduction)),
  devTools: !inProduction,
  reducer: rootReducer,
  preloadedState,
});

render(<Root store={store} />, document.getElementById('fplsFormBase'));
registerSW();